module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campusIdDetail"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("找回学号\n\t\t"), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.campusIdfb.status == '1') ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.disagree
    }
  }, [_vm._v("不通过")]) : _vm._e(), _vm._v(" "), (_vm.campusIdfb.status == '1') ? _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.agree
    }
  }, [_vm._v("通过")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "articleForm",
    attrs: {
      "model": _vm.campusIdfb,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.campusIdfb.name),
      callback: function($$v) {
        _vm.$set(_vm.campusIdfb, "name", $$v)
      },
      expression: "campusIdfb.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.campusIdfb.phone),
      callback: function($$v) {
        _vm.$set(_vm.campusIdfb, "phone", $$v)
      },
      expression: "campusIdfb.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.campusIdfb.school),
      callback: function($$v) {
        _vm.$set(_vm.campusIdfb, "school", $$v)
      },
      expression: "campusIdfb.school"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请学号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.campusIdfb.campusId),
      callback: function($$v) {
        _vm.$set(_vm.campusIdfb, "campusId", $$v)
      },
      expression: "campusIdfb.campusId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "label": "学生证照片"
    }
  }, [(_vm.campusIdfb.imgUrl1) ? _c('img', {
    staticStyle: {
      "height": "190px",
      "margin-right": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.campusIdfb.imgUrl1
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.campusIdfb.imgUrl2) ? _c('img', {
    staticStyle: {
      "height": "190px",
      "cursor": "pointer"
    },
    attrs: {
      "src": _vm.campusIdfb.imgUrl2
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showImg) ? _c('big-img', {
    staticClass: "bigImg",
    attrs: {
      "imgSrc": _vm.imgSrc,
      "name": _vm.campusIdfb.name,
      "school": _vm.campusIdfb.school,
      "campusId": _vm.campusIdfb.campusId
    },
    on: {
      "clickit": _vm.viewImg
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [(_vm.campusIdfb.imgUrl1 || _vm.campusIdfb.imgUrl2) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("双击查看大图")]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-737972af!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/userM/campusIdDetail.vue
// module id = 1073
// module chunks = 0